module.exports = __webpack_public_path__ + "img/info-icon.3fe87d83.svg";